/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class PendingRoute extends Route {
  // Services
  @service
  store;

  model() {
    const year = moment().year();
    const learnerQuery = {
      type: PersonType.LEARNER,
      status: EnrolmentStatus.PRE_ENROLLED,
      include: 'enrolments',
    };

    return hash({
      learners: this.store.query('person', learnerQuery),
      learnerFields: this.store.query('people-schema/field', {
        personType: PersonType.LEARNER,
      }),
      homerooms: this.store.query('group', {
        year,
        groupType: GroupType.HOMEROOM,
      }),
      nextYearHomerooms: this.store.query('group', {
        year: year + 1,
        groupType: GroupType.HOMEROOM,
      }),
    });
  }

  afterModel(model) {
    if (!isEmpty(model.nextYearHomerooms)) {
      let nextYear = moment().year() + 1;
      let nextYearsClassMap = model.nextYearHomerooms.reduce(
        (nextYearsClassMap, nextYearsClass) => {
          nextYearsClass.learners.forEach((learner) => {
            if (learner.status === 1) {
              nextYearsClassMap[learner.personId] =
                `${nextYearsClass.name} (${nextYear})`;
            }
          });
          return nextYearsClassMap;
        },
        {},
      );
      model.learners.forEach((person) => {
        person.set('nextYearsHomeroom', nextYearsClassMap[person.id] || '');
      });
    }
  }

  resetController(controller) {
    if (!isEmpty(controller)) {
      controller.reset();
    }
  }
}
